import styles from './getStarted.module.css'

const getStartedBoxStyle = {
  outer_box: `w-full rounded-[20px] border-[#FFF] border-2 relative py-[18px] pr-[30px] pl-[25px] flex flex-col justify-between
              xl:px-[35px]
              md:w-[300px]
              sm:w-[250px]
  `,
  top_right_outer_circle: `w-[100px] h-[100px] flex items-center justify-center absolute bg-darkColor -top-[15.5px] -right-[15.5px] rounded-full border-2 border-r-transparent border-b-transparent rotate-[-90deg]`,
  top_right_inner_circle: `bg-darkColor w-[95px] h-[95px] flex items-center justify-center rounded-full relative`,
  heading: `text-[20px] font-[700] text-white text-stroke
            sm:text-[26px]
  `,
  description: `text-[14px] font-[400] leading-[24px]
                sm:text-[16px]
  `,
  top_right_img: `rotate-[90deg] w-[inherit] h-[inherit]`,
  main_image: `h-[80px] w-[80px]
                md:h-[100px] md:w-[100px]
  `,
  step_text: `text-[17px] font-[600] leading-[normal] text-white ${styles.step_text_shadow} whitespace-nowrap absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 rotate-[90deg]`,
};


const getStartedStyle = {
  component_wrapper: `landing_page_component_wrapper flex flex-col items-center container`,
  token_card_wrpr: `flex flex-wrap items-center w-full gap-12 justify-center items-stretch
                    xl:gap-10
                    lg:flex-nowrap lg:gap-2 lg:justify-between 
                    sm:gap-[30px]
  `,
  arrow: `hidden min-w-[40px] w-auto max-w-[80px]
          lg:block
  `, 
};

export { getStartedStyle, getStartedBoxStyle };
